<template>
  <div class="collapse__item" :class="{active: !isCollapsed}">
    <div class="collapse__title" @click="onCollapse" ref="title">
      <h2>{{ title }}</h2>
      <div :class="[isCollapsed ? '' : 'active', 'collapse__item-ico']">
        <svg
          enable-background="new 0 0 14 9"
          width="14px"
          height="9px"
          viewBox="0 0 14 9"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clip-rule="evenodd"
            d="m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z"
            fill="currentColor"
            fill-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <div
      ref="contentRef"
      :style="{height}"
      :class="[{collapse__content: true}, {'collapse__content-active': !isCollapsed}]"
      v-html="content"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'Collapse',
  props: {
    title: String,
    content: String,
    isCollapsed: Boolean,
  },
  data() {
    return {
      maxHeight: '0',
    };
  },
  mounted() {
    this.calcHeight();
    window.addEventListener('resize', this.onResizeWindow);
  },
  computed: {
    height() {
      return this.isCollapsed ? '0' : this.maxHeight + 'px';
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.onResizeWindow);
  },
  methods: {
    onCollapse() {
      this.$emit('collapse', this.$refs['title']);
    },
    calcHeight() {
      this.maxHeight = this.$refs['contentRef'].scrollHeight;
    },
    onResizeWindow() {
      this.maxHeight = '0';
      this.$nextTick(() => this.calcHeight());
    },
  },
};
</script>
<style scoped>
.collapse__item {
  border-radius: 5px;
}
.collapse__item.active .collapse__title {
  border: none;
}
.collapse__item.active {
  border: thin solid var(--brand-color);
  padding-bottom: 17px;
}
.collapse__title {
  position: relative;
  border: thin solid var(--grey);
  background-color: #fff;
  border-radius: 5px;
  transition: 0.4s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
.collapse__item-ico {
  width: 14px;
  color: var(--grey);
}
.collapse__item-ico.active {
  transform: rotate(180deg);
  color: var(--brand-color);
}
.collapse__title > h2 {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 24px;
  font-variation-settings: 'wght' 700;
  padding: 15px 45px 15px 21px;
}
.collapse__sign-icon {
  width: 38px;
  transition: all 0.4s;
}
.collapse__title:hover {
  cursor: pointer;
}
.collapse__content {
  transition-property: all;
  transition-duration: 0.4s;
  overflow: hidden;
  padding: 0 54px 0 25px;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 20px;
  @media (--viewport-planshet) {
    font-size: 17px;
    line-height: 28px;
  }
}
</style>
